// src/economy/config.js — Kristal ve Oyuntu Puan kuralları (firestore.rules ile uyumlu tutun)
import gamesList from '../data/games.json';

export const DAILY_KRISTAL = 10; // her gün giriş hediyesi
export const COST_LOCAL = 1; // bilgisayara karşı oyun
export const COST_ONLINE = 2; // arkadaşlarla online oyun
export const COST_CHAT = 1; // sohbet mesajı
export const PUAN_PER_KRISTAL = 5; // market: 5 Oyuntu Puan = 1 Kristal
export const MAX_EARN = 30; // tek oyunda en fazla (kural sınırı)

/** Zorluk seviyesine göre kazanma ödülü (Oyuntu Puan) */
const WIN_BY_LEVEL = { Kolay: 5, Orta: 8, Zor: 12 };
const LEVEL = Object.fromEntries(gamesList.map((g) => [g.id, g.level]));

/** Oyun sonucu ödülü: kazanınca seviyeye göre, online ×2; kaybedince katılım 1 puan. */
export function gameReward(gameId, won, online) {
  if (!won) return 1;
  const base = WIN_BY_LEVEL[LEVEL[gameId]] || 6;
  return Math.min(MAX_EARN, online ? base * 2 : base);
}

/** Türkiye günü (UTC+3) sıra numarası — kurallardaki today() ile aynı */
export const dayNo = (ms = Date.now()) => Math.floor((ms + 10800000) / 86400000);
/** YYYY-MM-DD (Türkiye saati) */
export const dayStr = (ms = Date.now()) => new Date(ms + 10800000).toISOString().slice(0, 10);

/** Gün tohumlu karıştırma: herkese aynı gün aynı görevler */
export function seededPick(list, count, seed) {
  const arr = [...list];
  let x = seed * 2654435761 % 4294967296;
  for (let i = arr.length - 1; i > 0; i--) {
    x = (x * 1103515245 + 12345) % 2147483648;
    const j = x % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.slice(0, count);
}

export const GAME_NAMES = Object.fromEntries(gamesList.map((g) => [g.id, g.name]));

/** Görev/etkinlik açıklaması: "Pişti'de 3 kez kazan" */
export function goalText(g) {
  const where = !g.game || g.game === 'any' ? '' : `${GAME_NAMES[g.game] || g.game} · `;
  const online = g.mode === 'online' ? 'online ' : '';
  return `${where}${g.target} kez ${online}${g.type === 'win' ? 'kazan' : 'oyna'}`;
}

/** Oyun sonucu bir hedefe sayılır mı? */
export const goalMatches = (g, { gameId, won, online }) => (!g.game || g.game === 'any' || g.game === gameId) && (g.type !== 'win' || won) && (g.mode !== 'online' || online);
